import { useState } from "react";
import { Input } from "@/components/ui/input";

interface Props {
  index: number;
  question: string;
  options: string[];
  answered?: string;
  onAnswer: (answer: string) => void;
  disabled?: boolean;
}

export function InterviewQuestionCard({
  index,
  question,
  options,
  answered,
  onAnswer,
  disabled = false,
}: Props) {
  const [customText, setCustomText] = useState("");
  const isAnswered = answered !== undefined;

  return (
    <div
      className={`rounded-lg border p-3 ${
        isAnswered
          ? "border-border bg-muted/30"
          : "border-primary/30 bg-muted/50"
      }`}
    >
      <div className="mb-1 text-xs text-blue-400">Q{index + 1}</div>
      <div className="mb-2 text-sm font-medium">{question}</div>
      <div className="flex flex-wrap gap-1.5">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            disabled={disabled || isAnswered}
            onClick={() => onAnswer(opt)}
            className={`rounded-full px-2.5 py-1 text-xs transition-colors ${
              answered === opt
                ? "bg-primary text-primary-foreground font-semibold"
                : isAnswered
                  ? "bg-muted text-muted-foreground/50"
                  : "border border-border bg-muted hover:border-primary/50 cursor-pointer"
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
      {!isAnswered && (
        <div className="mt-2 flex gap-1.5">
          <Input
            value={customText}
            onChange={(e) => setCustomText(e.target.value)}
            placeholder="Or type your own..."
            className="h-7 text-xs"
            disabled={disabled}
            onKeyDown={(e) => {
              if (e.key === "Enter" && customText.trim()) {
                onAnswer(customText.trim());
              }
            }}
          />
        </div>
      )}
    </div>
  );
}
